import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    back: 'Back',
    battlingWithVerification: 'Battling with your account verification?',
    contactUs: 'Contact us at ',
    verifyingAccountHeading: 'Account Verification',
    verifyingAccountBlurb: 'You’re about to complete account verification securely within Altify, powered by our trusted verification partner.',
    verifcationSubmittedHeading: 'Verification Submitted',
    verifcationSubmittedBlurb: 'We\'re reviewing your details and will email you within 24 - 48 hours.\n\nIn the meantime, why not explore our investment options.',
    verifcationErrorHeading: 'Something Went Wrong',
    verifcationErrorBlurb: 'We\'re having trouble connecting to our verification provider to start your verification.\n\nThis is usually temporary. Please try again shortly.',
    continue: 'Continue',
    exploreInvestments: 'Explore Investments',
    tryAgain: 'Try Again',
  },
  de: {
    back: 'Back',
    battlingWithVerification: 'Battling with your account verification?',
    contactUs: 'Contact us at ',
    verifyingAccountHeading: 'Account Verification',
    verifyingAccountBlurb: 'You’re about to complete account verification securely within Altify, powered by our trusted verification partner.',
    verifcationSubmittedHeading: 'Verification Submitted',
    verifcationSubmittedBlurb: 'We\'re reviewing your details and will email you within 24 - 48 hours.\n\nIn the meantime, why not explore our investment options.',
    verifcationErrorHeading: 'Something Went Wrong',
    verifcationErrorBlurb: 'We\'re having trouble connecting to our verification provider to start your verification.\n\nThis is usually temporary. Please try again shortly.',
    continue: 'Continue',
    exploreInvestments: 'Explore Investments',
    tryAgain: 'Try Again',
  },
});
